import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c01f5c66"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["src"]
const _hoisted_2 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.visible)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "instruction",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onClick && _ctx.onClick(...args)))
      }, [
        _createElementVNode("img", {
          class: "hide-mobile",
          src: require('@/assets/images/' + _ctx.path)
        }, null, 8, _hoisted_1),
        _createElementVNode("img", {
          class: "hide-desktop",
          src: require('@/assets/images/' + _ctx.pathMobile)
        }, null, 8, _hoisted_2)
      ]))
    : _createCommentVNode("", true)
}